const swagger = {
    invalid_zod_type: 'نوع Zod غير صالح. يرجى التحقق من تكوين حارس المسار.',
    not_supported_zod_type_for_params: 'نوع Zod غير مدعوم للمعلمات. يرجى التحقق من تكوين حارس المسار.',
};
export default Object.freeze(swagger);
